import { useRef, useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import HappyClientsCard from "./HappyClientsCard";
import { SliderRightArrow } from "./Icons";

const HappyClientSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const clientFeedbacks = [
    { name: "Alice", feedback: "Great service! Highly recommended." },
    { name: "Bob", feedback: "Amazing experience with the team!" },
    { name: "Charlie", feedback: "Top-notch support and delivery." },
    { name: "David", feedback: "Smooth and fast booking process!" },
  ];

  useEffect(() => {
    if (
      swiperInstance &&
      swiperInstance.params &&
      prevRef.current &&
      nextRef.current
    ) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;

      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className="relative">
      <div className="2xl:max-w-[1240px] container mx-auto pt-2 sm:px-5">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={0}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 3,
            },
          }}
        >
          {clientFeedbacks.map((client, index) => (
            <SwiperSlide key={index}>
              <HappyClientsCard obj={client} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Custom Arrows */}
      <div className="flex justify-center gap-3">
        <button
          ref={prevRef}
          className="transition sm:absolute sm:top-1/2 top-full sm:-translate-y-1/2 xl:left-4 2xl:-left-10 sm:left-2 left-[35%] z-10 flex flex-col justify-center"
        >
          <span className="inline-block rotate-[180deg]">
            <SliderRightArrow />
          </span>
        </button>
        <button
          ref={nextRef}
          className="transition sm:absolute sm:top-1/2 top-full sm:-translate-y-1/2 xl:right-4 2xl:-right-10 sm:right-2 right-[35%] z-10 flex flex-col justify-center"
        >
          <SliderRightArrow />
        </button>
      </div>
    </div>
  );
};

export default HappyClientSlider;
